<template>
  <div
    class="fixed top-0 bottom-0 left-0 right-0 z-50 pb-12"
    style="background: rgba(0, 0, 0, 0.3); overflow-y: auto"
    v-if="state.open"
  >
    <div class="mx-auto container">
      <div class="bg-white rounded shadow p-2 border border-gray-100 opacity-100 mt-12">
        <div class="flex flex-row items-center">
          <p class="p-2 font-medium flex-grow text-primary">Revision History</p>
          <IconButton icon="times" @click="close" class="cancel" />
        </div>
        <div class="overflow-x-auto">
          <table class="w-full text-sm">
            <thead>
              <tr class="border-b border-gray-200">
                <th class="text-left p-2 font-medium text-primary">Revision</th>
                <th class="text-left p-2 font-medium text-primary">Date</th>
                <th class="text-right p-2 font-medium text-primary">Download</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="row in sortedRefs"
                :key="row.key"
                class="border-b border-gray-100 hover:bg-gray-50"
              >
                <td class="p-2 font-medium">{{ row.revision }}</td>
                <td class="p-2 text-text">{{ row.date }}</td>
                <td class="p-2 text-right">
                  <button
                    class="success text-xs px-3 py-1"
                    :disabled="state.loadingKeys[row.key]"
                    @click="downloadRevision(row.key)"
                  >
                    <span v-if="state.loadingKeys[row.key]">Loading…</span>
                    <span v-else>Download</span>
                  </button>
                </td>
              </tr>
              <tr v-if="sortedRefs.length === 0">
                <td colspan="3" class="p-4 text-center text-gray-400">No revisions found.</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="flex flex-row items-center mt-2">
          <button class="primary" @click="close">Close</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive, computed } from "vue";
import { IconButton } from "@comp";
import { db } from "../../../db.js";
import { useStore } from "vuex";
import { matrixReport } from "./reports.js";
import { revisionSnapshotsPath, STC_VARIANT } from "../_variants/index.js";

const store = useStore();

const state = reactive({
  open: false,
  refs: {},
  loadingKeys: {},
  variant: STC_VARIANT,
});

const sortedRefs = computed(() => {
  return Object.entries(state.refs)
    .map(([key, value]) => {
      const separatorIndex = value.indexOf(" - ");
      const revision = separatorIndex !== -1 ? value.slice(0, separatorIndex).trim() : value;
      const date = separatorIndex !== -1 ? value.slice(separatorIndex + 3).trim() : "";
      return { key, revision, date };
    })
    .sort((a, b) => a.revision.localeCompare(b.revision));
});

function open(refs, variant = STC_VARIANT) {
  state.refs = refs || {};
  state.loadingKeys = {};
  state.variant = variant;
  state.open = true;
}

function close() {
  state.open = false;
}

async function downloadRevision(key) {
  state.loadingKeys[key] = true;
  try {
    const revSnapshotsPathStr = revisionSnapshotsPath(state.variant);
    const rev = await db.once(`${revSnapshotsPathStr}/${key}`);
    if (rev) {
      await matrixReport(rev, { store });
    }
  } finally {
    state.loadingKeys[key] = false;
  }
}

defineExpose({ open, close });
</script>
